import React from "react";
import { useEffect, useState } from "react";

export default function NamePopUp({
  handelClosePopUpClick,
  popupflag,
  cancelBtnCallBack,Education
}) {
  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "#00000055" }}
      >
        <div className="modal-dialog mt-lg-5 pt-lg-4" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
               Contact Person Information
              </h5>
              <button
                onClick={() =>cancelBtnCallBack()}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mx-4">
              <div className="row ">
                <div className="col-md-12 ">

                  <div className="v_row ">
                    <text style={{ width: "40%" }}> Contact Person Name  </text>
                    <text style={{width:"10%"}} className="font-weight-bold ml-2">:</text>
                    <text className="font-weight-bold ml-2">Name</text>
                  </div>

                  <div className="v_row">
                    <text style={{ width: "40%" }}> Profession </text>
                    <text style={{width:"10%"}} className="font-weight-bold ml-2">:</text>
                    <text className="font-weight-bold ml-2">Devloper</text>
                  </div>
                  {
                    Education ? 
                    <div className="v_row">
                    <text style={{ width: "40%" }}> Education </text>
                    <text style={{width:"10%"}} className="font-weight-bold ml-2">:</text>
                    <text className="font-weight-bold ml-2">{Education}</text>
                  </div> : ""
                  }
                  
                  <div className="v_row">
                    <text style={{ width: "40%" }}> Mobile Number  </text>
                    <text style={{width:"10%"}} className="font-weight-bold ml-2">:</text>
                    <text className="font-weight-bold ml-2">1234567890</text>
                  </div>

                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
